import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import focusManager from 'support/focus/FocusManager';
import device from 'common/support/device';
import {
  syncRealFocusOnVega,
  cancelPendingRealFocusSync,
} from 'support/focus/realFocusSync';
import { setRequestedFocusId } from 'actions/dialog';
import { VideoCtvRedux } from '../store-types';

export const useFocusManager = () => {
  const isDialogOpen = useSelector((state: VideoCtvRedux) => state.dialog.isOpen);

  const dispatch = useDispatch();
  const setCurrentFocus = (...args: [(string|number)?]) => {
    if (!isDialogOpen) {
      return focusManager.setCurrentFocus(...args);
    }

    const id: string | number | null | undefined = args[0];
    dispatch(setRequestedFocusId(id));

    return undefined;
  };

  const focusManagerRef = useRef(Object.create(focusManager));
  focusManagerRef.current.setCurrentFocus = setCurrentFocus;

  return focusManagerRef.current;
};

export const useVegaRealFocusSync = (): void => {
  useEffect(() => {
    const onFocusChanged = (newId: string | number | null) => {
      if (!device.isVega) return;
      syncRealFocusOnVega(newId);
    };

    focusManager.addFocusChangedListener(onFocusChanged);

    onFocusChanged(focusManager.currentFocusId);

    return () => {
      focusManager.removeFocusChangedListener(onFocusChanged);
      cancelPendingRealFocusSync();
    };
  }, []);
};
